import { Action } from 'redux';
import { ContractCommissionAgentConceptState, ContractCommissionAgentConceptUnloadState } from '../states/ContractCommissionAgentConceptState';

export default function ContractCommissionAgentConceptReducer(
  state: ContractCommissionAgentConceptState | undefined,
  action: Action
): ContractCommissionAgentConceptState {
  const currentState = state ?? ContractCommissionAgentConceptUnloadState;
  const a: any = action;

  switch (a.type) {
    // CREATE
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_CREATE_REQUEST':
      return {
        ...currentState,
        isAddingNewOne: true,
        successAddingNewOne: false,
        failOnAddingNewOne: false,
        error: undefined
      };
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_CREATE_SUCCESS':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
        error: undefined
      };
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_CREATE_FAILURE':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: a.error
      };

    // UPDATE
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_UPDATE_REQUEST':
      return {
        ...currentState,
        isUpdatingOne: true,
        successUpdatingOne: false,
        failOnUpdatingOne: false,
        error: undefined
      };
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_UPDATE_SUCCESS':
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: true,
        failOnUpdatingOne: false,
        error: undefined
      };
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_UPDATE_FAILURE':
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: false,
        failOnUpdatingOne: true,
        error: a.error
      };

    // DELETE
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_DELETE_REQUEST':
      return {
        ...currentState,
        isDeletingOne: true,
        successDeletingOne: false,
        failOnDeletingOne: false,
        error: undefined
      };
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_DELETE_SUCCESS':
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: true,
        failOnDeletingOne: false,
        error: undefined
      };
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_DELETE_FAILURE':
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: false,
        failOnDeletingOne: true,
        error: a.error
      };

    // GET ALL
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_GET_ALL_BY_COMMISSION_AGENT_ID_REQUEST':
      return {
        ...currentState,
        isLoadingAll: true,
        successLoadingAll: false,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_GET_ALL_BY_COMMISSION_AGENT_ID_SUCCESS':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'CONTRACT_COMMISSION_AGENT_CONCEPT_GET_ALL_BY_COMMISSION_AGENT_ID_FAILURE':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: a.error
      };

    default:
      return currentState;
  }
}
